// extracted by mini-css-extract-plugin
module.exports = {"Categories":"Styles_Categories__1gurr"};